import React from 'react';
import './style.scss';
import { NFTBgColors } from 'shared';
import SVGCarouselArrow from '../../../../../../assets/images/carousel/arrow';
import { toBgColor } from '../../../../../../utils/color';

interface Props {
  color: NFTBgColors;
  direction: 'right' | 'left' | 'top' | 'bottom';
  size: number;
}

const NftsCarouselArrow = ({ color, direction, size }: Props) => {
  const hexColor = toBgColor(color);

  return (
    <SVGCarouselArrow
      size={size}
      color={hexColor}
      className={`nft-carousel-arrow-${direction}`}
    />
  );
};

export default NftsCarouselArrow;
